<template>
    <AppScaffold grid>
        <Card v-if="data && !loading">
            <h1>{{ $tradFor(data.terms.name) }}</h1>
            <nav>
                <RoundedButton @click="$router.go(-1);">{{ $trad.common.cancel }}</RoundedButton>
                <RoundedButton @click="save">{{ $trad.common.save }}</RoundedButton>
            </nav>
            <table>
                <tbody>
                    <tr>
                        <td>
                            <label for="color">{{ $trad.frameEditor.colorLabel }}</label>
                        </td>
                        <td><input id="color" type="color" v-model="frameConfig.color" /> <input type="text" v-model="frameConfig.color" /></td>
                    </tr>
                    <tr>
                        <td>{{ $trad.frameEditor.width }}</td>
                        <td><NumericInput v-model="frameConfig.width"></NumericInput></td>
                    </tr>
                    <tr>
                        <td>{{ $trad.frameEditor.height }}</td>
                        <td><NumericInput v-model="frameConfig.height"></NumericInput></td>
                    </tr>
                    <tr>
                        <td>{{ $trad.frameEditor.thickness }}</td>
                        <td><NumericInput v-model="frameConfig.thickness"></NumericInput></td>
                    </tr>
                </tbody>
            </table>
        </Card>
        <Card v-else> <Loader :loading="true"></Loader> </Card>
    </AppScaffold>
</template>

<script>
import AppScaffold from "@/app-scaffold";
import TryLoad from "@/mixins/TryLoadMixin";
import componentService from "@/services/component";
import Loader from "@/components/loader/loader";
import Card from "./components/card";
import RoundedButton from "./components/rounded-button";
import NumericInput from "@/plano/components/number-input.vue";

export default {
    components: { AppScaffold, Loader, Card, RoundedButton, NumericInput },
    mixins: [TryLoad],
    data: () => ({
        data: undefined,
        frameConfig: {
            width: 0,
            height: 0,
            color: "#ffff00",
            thickness: 0
        }
    }),
    computed: {
        frameId() {
            return this.$route.params.id && Number.parseInt(this.$route.params.id, 10);
        },
        component() {
            return (
                this.data && {
                    ...this.data,
                    config: this.frameConfig
                }
            );
        }
    },
    created() {
        this.fetchframe();
    },
    methods: {
        async fetchframe() {
            this.data = await this.tryLoad(() => componentService.get(this.frameId));
            this.frameConfig = {
                ...this.frameConfig,
                ...this.data.config
            };
        },
        async save() {
            try {
                await componentService.updateConfig(this.frameId, {
                    width: Number.parseFloat(this.frameConfig.width, 10),
                    height: Number.parseFloat(this.frameConfig.height, 10),
                    thickness: Number.parseFloat(this.frameConfig.thickness, 10),
                    color: this.frameConfig.color
                });
                this.$router.go(-1);
            } catch (err) {
                this.dialogError(err);
                throw err;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// frame-editor.vue?172e76e7